<template>
<div>
  <vb-form-row item-name="支援先" :required="true">
    <template #input>
      <v-sheet width="100%" :max-width="null">
        <validation-provider v-slot="{ errors, invalid }" name="支援先" rules="required">
          <v-select
            v-model="supportGroupSelected"
            :items="supportGroups"
            item-text="name"
            item-value="id"
            :error-messages="errors"
            required
            outlined
            dense
            height="44px"
            return-object
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            hide-details="auto"
            solo
            flat
          >
            <template #label><span class="text-body-2">支援先</span></template>
          </v-select>
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
export default {
  name: "vb-support-group",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
      supportGroups: [],
    }
  },
  created() {
    this.fetchSupportGroups();
  },
  computed: {
    supportGroupSelected: {
      get() {
        return this.formItemsGetter.supportGroupId;
      },
      set(value) {
        this.formItemsSetter({name:'supportGroupId', value: value.id});
        this.formItemsSetter({name:'supportGroupName', value: value.name});
      }
    },
  },
  methods: {
    fetchSupportGroups() {
      const paramId = this.formItemsGetter.requestParamSupportGroupId;
      axios.get('/api/ajax/supportgroup', {
          params: {
            supportgroup_id: paramId
          }
        }).then(response => {
          this.supportGroups = response.data;
          if (this.supportGroups.length === 1) {
            this.supportGroupSelected = this.supportGroups[0];
          }
        });
    },
  }
}
</script>

<style scoped>

</style>